import { AxiosPromise } from 'axios';
import { IVisitorLoginPageFormValues } from './types';
import { instance } from '../../../services';

const attemptVisitorLogin = (data: IVisitorLoginPageFormValues): AxiosPromise =>
  instance.post('api/accounts/visitor', data);

export default attemptVisitorLogin;
